// action - state management
import { REGISTER, LOGIN, LOGOUT, SET_ONBOARDING } from './actions';

// types
import { AuthProps, AuthActionProps } from 'types/auth';

// initial state
const initialState: AuthProps = {
  isLoggedIn: false,
  isInitialized: false,
  user: null
};

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state = initialState, action: AuthActionProps) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload!;
      return {
        ...state,
        user
      };
    }
    case LOGIN: {
      const { user } = action.payload!;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        onboardingComplete: false,
        user: null
      };
    }
    case SET_ONBOARDING: {
      return {
        ...state,
        onboardingComplete: action.payload?.onboardingComplete ?? false
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default auth;
